// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"295":"dc29689e","549":"dc29689e","690":"6e64f272"}[chunkId] + ".chunk.css";
};